{
  "GenericModal_PromptMessage": "Are you sure you want to close this window? All modified configurations will be lost when closed.",
  "GenericModal_PromptConfirm": "Yes",
  "GenericModal_PromptCancel": "Cancel",
  "NAME": "GenericModal"
}